import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import messages from 'store/app/entities/messages/action';
import authCompany from 'store/selectors/authCompany';
import authEmployee from 'store/selectors/authEmployee';
import authUser from 'store/selectors/authUser';
import currentChannel from 'store/selectors/currentChannel';
import isCompanyAdmin from 'store/selectors/isCompanyAdmin';

const mapStateToProps = state => ({
  message: state.drawers.acknowledgeCreate.message,
  tempAttachment: state.drawers.acknowledgeCreate.tempAttachment,
  sentAsChannel: state.drawers.acknowledgeCreate.sentAsChannel,
  digitalSignatureMode: state.drawers.acknowledgeCreate.digitalSignatureMode,
  authCompany: authCompany(state),
  authEmployee: authEmployee(state),
  authUser: authUser(state),
  channel: currentChannel(state),
  isCompanyAdmin: isCompanyAdmin(state),
});

const mapDispatchToProps = dispatch => ({
  actions: {
    messages: bindActionCreators(messages, dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
